// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { PropTypes } from 'prop-types';
import dynamic from 'next/dynamic';
import LabelsContext from '@tcp/core/src/components/common/context/LabelsContext';
import { parseBoolean, styleOverrideEngine, getAPIConfig } from '@tcp/core/src/utils';
import { getUserLoggedInState } from '@tcp/core/src/components/features/account/User/container/User.selectors';
import { openPickupModalWithValues } from '@tcp/core/src/components/common/organisms/PickupStoreModal/container/PickUpStoreModal.actions';
import {
  fetchRecommendationsDataMonetate,
  fetchRecommendationsDataAdobe,
  sendEventsToMonetate,
} from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.actions';
import {
  getProducts,
  getLoadedProductsCount,
  getFirstSuggestedProduct,
  getMonetateEnabledFlag,
  getLabelsProductListingCopy,
} from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.selector';
import { openQuickViewWithValues } from '@tcp/core/src/components/common/organisms/QuickViewModal/container/QuickViewModal.actions';
import {
  getIsDynamicBadgeEnabled,
  getIsPDPSmoothScrollEnabled,
  getIsBIAEnabled,
  getIsHomePageRAR,
  getIsHomeBirthdayModule,
  getABTestIsHomePageInYourBagEnabled,
  getIsHomepageFullPageWidthEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import RecommendationsView from '@tcp/core/src/components/common/molecules/Recommendations';
// import StyliticsCarousel from '@tcp/core/src/components/common/molecules/StyliticsCarousel/views/StyliticsCarousel.view';
import {
  getCurrentCurrency,
  getCurrencyAttributes,
} from '@tcp/core/src/reduxStore/selectors/currency.selectors';
import {
  getLabelFromCopyOrFromTranslation,
  getDynamicLabelValues,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels,
} from '@tcp/core/src/utils/labels/globalAccessibility.labels';
import EspotPlpPromo from '@tcp/core/src/components/common/molecules/EspotPlpPromo';
import {
  ctaText as ctaTextKey,
  ctaTitle as ctaTitleKey,
  RecommendationLabels,
  GLOBAL_RECOMMENDATIONS,
} from '@tcp/core/src/components/common/molecules/Recommendations/container/Recommendations.labels';
import ShopByLookStylitics from '@tcp/core/src/components/common/molecules/ShopByLookStylitics';
import SafeComponent from '../../../hoc/withErrorBoundary';
import { GlobalGenericLabels } from '../../../../../utils/labels/globalGeneric.labels';
import { globalCommonBrowseLabels } from '../../../../../utils/labels/globalCommonBrowseLabels.labels';
import { globalSortingLabels } from '../../../../../utils/labels/globalSorting.labels';
import { PLPLabels } from '../../../../../utils/labels/browse/PLP.labels';

const BuyItAgainView = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "BuyItAgain" */ '@tcp/core/src/components/features/account/BuyItAgain'
  )
);

const RateAndReviewModule = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "RateAndReview" */ '@tcp/core/src/components/features/account/RatingReview'
  )
);

const CrossBrandModule = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "CrossBrand" */ '@tcp/core/src/components/common/molecules/CrossBrand'
  )
);

const BirthDayModule = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "BirthDayModule" */ '@tcp/core/src/components/features/account/BirthdayModule'
  )
);

const InYourBagView = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "InYourBagModule" */ '@tcp/core/src/components/features/browse/InYourBag/container/InYourBag.container'
  )
);

const SubscriptionEmail = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "SubscriptionEmail" */ '@tcp/core/src/components/common/molecules/SubscriptionEmail'
  )
);

const SubscriptionSMS = dynamic(() =>
  import(
    // eslint-disable-next-line extra-rules/no-commented-out-code
    /* webpackChunkName: "SubscriptionSMS" */ '@tcp/core/src/components/common/molecules/SubscriptionSMS'
  )
);

const appendFullWidthStyle = {
  padding: '0 32px',
};

const recommLabels = getLabelFromCopyOrFromTranslation(
  GLOBAL_RECOMMENDATIONS,
  RecommendationLabels
);

const accessibilityLabels = getLabelFromCopyOrFromTranslation(
  GLOBAL_ACCESSIBILITY_LABELS,
  GlobalAccessibilityLabels
);

const dynamicHomeLabels = getDynamicLabelValues('dynamic.home');

const ctaLabelText = renderLabel(recommLabels[ctaTextKey], ctaTextKey);
const ctaTitleLabelText = renderLabel(recommLabels[ctaTitleKey], ctaTitleKey);

const nextIconButtonLabel = renderLabel(accessibilityLabels.nextIconButton, 'nextIconButton');

const previousButtonLabel = renderLabel(accessibilityLabels.previousButton, 'previousButton');

const CtaUrlLabelValue = getDynamicLabelValues('dynamic.home.CTA_URL');

const providerType = {
  ADOBE: 'Adobe',
  BUY_IT_AGAIN: 'buy_it_again',
  RATE_AND_REVIEW: 'rate_review',
  CROSS_BRAND: 'cross_brand',
  BIRTHDAY: 'birthday',
  IN_YOUR_BAG: 'in_your_bag',
  ESPOT_PLP: 'espot_plp',
  STYLITICS_CAROUSEL: 'stylitics_carousel',
  EMAIL_SUBSCRIPTION_SIGNUP: 'email_signup_hp',
  SMS_SUBSCRIPTION_SIGNUP: 'sms_sign_up_hp',
};

const getCampaignId = ({ language, CAMPAIGN_ID, CAMPAIGN_ID_FR, CAMPAIGN_ID_ES }) => {
  const localizedCampaigns = {
    fr: CAMPAIGN_ID_FR,
    es: CAMPAIGN_ID_ES,
  };
  return !isEmpty(localizedCampaigns[language]) ? localizedCampaigns[language] : CAMPAIGN_ID;
};

class ModuleDynamic extends React.PureComponent {
  static contextType = LabelsContext;

  renderAdobeModule = () => {
    const { isHomepageFullPageWidthEnabled, isHomePage } = this.props;
    const isHomepageFullWidthView = isHomepageFullPageWidthEnabled && isHomePage;
    const styleObj = isHomepageFullWidthView ? appendFullWidthStyle : {};

    return (
      <div style={styleObj}>
        <RecommendationsView {...this.props} recommendationCarouselRedesign />
      </div>
    );
  };

  renderBIAModule = () => {
    const {
      isUserLoggedIn,
      singleCTAButton,
      headerText,
      moduleClassName,
      moduleName,
      cacheTTL,
      sortingOrder,
      categoryCode,
      isBIAEnabled,
      dateOnlySorting,
      isHpNewModuleDesignEnabled,
      noOfProducts,
      isHomePage,
    } = this.props;
    const { extraConfig } = this.context;
    const { isDamImageV2Enabled } = extraConfig || {};
    const styleOverrides = !isEmpty(moduleClassName)
      ? styleOverrideEngine(moduleClassName, 'ModuleDynamic')
      : {};
    const bgStyleOverrides = styleOverrides['bia-bgColor'] || {};

    if (isUserLoggedIn && isBIAEnabled) {
      return (
        <div className={`${moduleClassName} ${moduleName}-BIA`}>
          <BuyItAgainView
            singleCTAButton={singleCTAButton}
            headerText={headerText}
            cacheTTL={cacheTTL}
            sortingOrder={sortingOrder}
            categoryCode={categoryCode}
            dateOnlySorting={parseBoolean(dateOnlySorting)}
            backgroundColor={bgStyleOverrides}
            isHpNewModuleDesignEnabled={isHpNewModuleDesignEnabled}
            noOfProducts={noOfProducts}
            isHomePageView={isHomePage}
            isDamImageV2Enabled={isDamImageV2Enabled}
          />
        </div>
      );
    }
    return <></>;
  };

  renderRateAndReviewModule = () => {
    const {
      isUserLoggedIn,
      headerText,
      moduleClassName,
      moduleName,
      isHpNewModuleDesignEnabled,
      isHomePageRAREnabled,
      isHomePage,
      isHomepageFullPageWidthEnabled,
    } = this.props;
    const { extraConfig } = this.context;
    const { isDamImageV2Enabled } = extraConfig || {};
    const styleOverrides = !isEmpty(moduleClassName)
      ? styleOverrideEngine(moduleClassName, 'ModuleDynamic')
      : {};
    const bgStyleOverrides = styleOverrides['rnr-bgColor'] || {};
    const styleProp = isHomepageFullPageWidthEnabled ? { paddingLeft: 32, paddingRight: 32 } : {};
    if (isUserLoggedIn && isHomePageRAREnabled) {
      return (
        <div className={`${moduleClassName} ${moduleName}-rnr`} style={styleProp}>
          <RateAndReviewModule
            headerText={headerText}
            backgroundColor={bgStyleOverrides}
            isHpNewModuleDesignEnabled={isHpNewModuleDesignEnabled}
            isHomePageView={isHomePage}
            isDamImageV2Enabled={isDamImageV2Enabled}
            isHomepageFullPageWidthEnabled={isHomepageFullPageWidthEnabled}
          />
        </div>
      );
    }
    return <></>;
  };

  renderCrossBrandModule = () => {
    return <CrossBrandModule {...this.props} />;
  };

  renderBirthDayModule = () => {
    const {
      isHpBirthdayModuleEnabled,
      birthday,
      LOYALTY_DISCOUNT,
      LOYALTY_MESSAGE,
      PLCC_MESSAGE,
      HOMEPAGE_BIRTHDAY_MODULE_THRESHOLD,
      PLCC_DISCOUNT,
      set,
      moduleClassName,
      isHpNewModuleDesignEnabled,
      isHpNewDesignCTAEnabled,
      isHomePage,
    } = this.props;
    const { extraConfig } = this.context;
    const { isDamImageV2Enabled } = extraConfig || {};
    if (isHpBirthdayModuleEnabled) {
      return (
        <BirthDayModule
          birthday={birthday}
          loyaltyDiscount={LOYALTY_DISCOUNT}
          loyaltyMsg={LOYALTY_MESSAGE}
          plccMsg={PLCC_MESSAGE}
          displayThreshold={HOMEPAGE_BIRTHDAY_MODULE_THRESHOLD || 2}
          plccDiscount={PLCC_DISCOUNT}
          set={set}
          moduleClassName={moduleClassName}
          isHpNewModuleDesignEnabled={isHpNewModuleDesignEnabled}
          isHpNewDesignCTAEnabled={isHpNewDesignCTAEnabled}
          isHomePageView={isHomePage}
          isDamImageV2Enabled={isDamImageV2Enabled}
        />
      );
    }
    return <></>;
  };

  renderInYourBagModule = () => {
    return <InYourBagView {...this.props} />;
  };

  renderESpotModule = () => {
    return <EspotPlpPromo {...this.props} />;
  };

  renderStyliticsCarouselModule = () => {
    const { isInGridPromo, moduleClassName } = this.props;
    const styleOverrides = !isEmpty(moduleClassName)
      ? styleOverrideEngine(moduleClassName, 'ModuleDynamic')
      : {};
    const imageFitTypeOverride = styleOverrides?.imageFitType || {};

    if (isInGridPromo) {
      return <ShopByLookStylitics {...this.props} imageFitTypeOverride={imageFitTypeOverride} />;
    }
    // TODO - to be removed once we add the support for in ShopByLook module
    // return <StyliticsCarousel {...this.props} />;
    return null;
  };

  renderEmailSubscription = () => {
    const { language } = getAPIConfig();
    const { slotIndex, provider, CAMPAIGN_ID, CAMPAIGN_ID_FR, CAMPAIGN_ID_ES, moduleClassName } =
      this.props;
    const campaignIdVal = getCampaignId({ language, CAMPAIGN_ID, CAMPAIGN_ID_FR, CAMPAIGN_ID_ES });
    const styleOverrides = !isEmpty(moduleClassName)
      ? styleOverrideEngine(moduleClassName, 'ModuleDynamic')
      : {};
    const textColorOverride = styleOverrides['text-color'] || {};
    const hideEmailDisclaimer = styleOverrides?.hideDisclaimer || {};
    return (
      <SubscriptionEmail
        campaignId={campaignIdVal}
        textColorOverride={textColorOverride}
        hideDisclaimer={hideEmailDisclaimer}
        classNameVal={`${provider}_slot_${slotIndex}`}
      />
    );
  };

  renderSmsSubscription = () => {
    const { slotIndex, provider, moduleClassName } = this.props;
    const styleOverrides = !isEmpty(moduleClassName)
      ? styleOverrideEngine(moduleClassName, 'ModuleDynamic')
      : {};
    const textColorOverride = styleOverrides['text-color'] || {};
    const hideSMSDisclaimer = styleOverrides?.hideDisclaimer || {};
    return (
      <SubscriptionSMS
        textColorOverride={textColorOverride}
        hideDisclaimer={hideSMSDisclaimer}
        classNameVal={`${provider}_slot_${slotIndex}`}
      />
    );
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  render() {
    const { isUserLoggedIn, provider, isHomePageInYourBagEnabled } = this.props;

    if (provider === providerType.RATE_AND_REVIEW) {
      return isUserLoggedIn ? this.renderRateAndReviewModule() : <></>;
    }

    if (provider === providerType.ADOBE) {
      return this.renderAdobeModule();
    }

    if (provider === providerType.BUY_IT_AGAIN) {
      return isUserLoggedIn ? this.renderBIAModule() : <></>;
    }

    if (provider === providerType.CROSS_BRAND) {
      return this.renderCrossBrandModule();
    }

    if (provider === providerType.BIRTHDAY) {
      return isUserLoggedIn ? this.renderBirthDayModule() : <></>;
    }

    if (provider === providerType.IN_YOUR_BAG) {
      return isHomePageInYourBagEnabled ? this.renderInYourBagModule() : <></>;
    }
    if (provider === providerType.ESPOT_PLP) {
      return this.renderESpotModule();
    }

    if (provider === providerType.STYLITICS_CAROUSEL) {
      return this.renderStyliticsCarouselModule();
    }
    if (provider === providerType.EMAIL_SUBSCRIPTION_SIGNUP) {
      return this.renderEmailSubscription();
    }

    if (provider === providerType.SMS_SUBSCRIPTION_SIGNUP) {
      return this.renderSmsSubscription();
    }

    return <></>;
  }
}

function getRecommendationProducts(state, ownProps, partNumber, reduxKey, isSequenceTwo) {
  const { isSuggestedItem } = ownProps;

  let { page } = ownProps;
  if (page === 'home page') page = 'homepage';

  const MONETATE_ENABLED = getMonetateEnabledFlag();
  let products = [];
  if (MONETATE_ENABLED === true)
    products = isSuggestedItem
      ? getFirstSuggestedProduct(state, partNumber)
      : getProducts(state, page || 'homepageTest');
  else {
    products = isSuggestedItem
      ? getFirstSuggestedProduct(state, partNumber)
      : getProducts(state, reduxKey);
    return products;
  }

  if (!Array.isArray(products)) return [];
  return products.filter((product) => {
    return isSequenceTwo ? product.isRecentViewed : !product.isRecentViewed;
  });
}

const mapStateToProps = (state, ownProps) => {
  const { portalValue, excludedIds, partNumber, sequence } = ownProps;
  const MONETATE_ENABLED = getMonetateEnabledFlag(state);
  let { page } = ownProps;
  if (page === 'home page') page = 'homepage';
  const newPortalValue = portalValue;
  const abTestConfig = null;
  const labelSuffix = `${page}_${sequence}`;
  const isSequenceTwo = sequence === '2';
  const moduleOHeaderLabel = isSequenceTwo
    ? renderLabel(dynamicHomeLabels.lbl_home_moduleO_sequence_2, 'lbl_home_moduleO_sequence_2')
    : renderLabel(dynamicHomeLabels.lbl_home_moduleO_sequence_1, 'lbl_home_moduleO_sequence_1');

  const modulePHeaderLabel = isSequenceTwo
    ? renderLabel(dynamicHomeLabels.lbl_home_moduleP_sequence_2, 'lbl_home_moduleP_sequence_2')
    : renderLabel(dynamicHomeLabels.lbl_home_moduleP_sequence_1, 'lbl_home_moduleP_sequence_1');

  const reduxKey = `${page}_${newPortalValue || 'global'}productsData`;
  const ctaText = abTestConfig ? `CTA_TEXT_${labelSuffix}` : ctaLabelText;
  const ctaTitle = abTestConfig ? `CTA_TITLE_${labelSuffix}` : ctaTitleLabelText;
  const ctaUrl = abTestConfig ? `CTA_URL_${labelSuffix}` : CtaUrlLabelValue;
  const getLabels = () => {
    return {
      global: {
        generic: getLabelFromCopyOrFromTranslation('global.generic', GlobalGenericLabels),
        CommonBrowseLabels: getLabelFromCopyOrFromTranslation(
          'global.CommonBrowseLabels',
          globalCommonBrowseLabels
        ),
        Sorting: getLabelFromCopyOrFromTranslation('global.Sorting', globalSortingLabels),
      },
      PLP: getLabelFromCopyOrFromTranslation('PLP', PLPLabels),
    };
  };

  return {
    categoryName: ownProps.categoryName,
    products: getRecommendationProducts(state, ownProps, partNumber, reduxKey, isSequenceTwo),
    moduleOHeaderLabel,
    modulePHeaderLabel,
    ctaText,
    ctaTitle,
    ctaUrl,
    ariaPrevious: previousButtonLabel,
    ariaNext: nextIconButtonLabel,
    loadedProductCount: getLoadedProductsCount(state),
    labels: getLabelsProductListingCopy(getLabels()),
    currency: getCurrentCurrency(state),
    currencyAttributes: getCurrencyAttributes(state),
    reduxKey,
    excludedIds,
    portalValue: newPortalValue,
    showPriceRange: ownProps.showPriceRange,
    cartItems: [],
    isBagLoading: false,
    isOutfitLoading: false,
    outfitItems: [],
    MONETATE_ENABLED,
    isDynamicBadgeEnabled: getIsDynamicBadgeEnabled(state),
    isPDPSmoothScrollEnabled: getIsPDPSmoothScrollEnabled(state),
    isNewPDPEnabled: true,
    isUserLoggedIn: getUserLoggedInState(state),
    isBIAEnabled: getIsBIAEnabled(state),
    isHomePageRAREnabled: getIsHomePageRAR(state),
    isHpBirthdayModuleEnabled: getIsHomeBirthdayModule(state),
    isHomePageInYourBagEnabled: getABTestIsHomePageInYourBagEnabled(state),
    isHomepageFullPageWidthEnabled: getIsHomepageFullPageWidthEnabled(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadRecommendationsMonetate: (action) => {
      dispatch(fetchRecommendationsDataMonetate(action));
    },
    loadSendEventsToMonetate: (action) => {
      dispatch(sendEventsToMonetate(action));
    },
    loadRecommendationsAdobe: (action) => {
      dispatch(fetchRecommendationsDataAdobe(action));
    },
    onPickUpOpenClick: (payload) => {
      dispatch(openPickupModalWithValues(payload));
    },
    onQuickViewOpenClick: (payload) => {
      dispatch(openQuickViewWithValues(payload));
    },
  };
};

ModuleDynamic.propTypes = {
  isHomePage: PropTypes.bool,
  provider: PropTypes.string.isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  moduleName: PropTypes.string.isRequired,
  moduleClassName: PropTypes.string,
  isHpNewModuleDesignEnabled: PropTypes.bool,
  headerText: PropTypes.arrayOf(PropTypes.shape({})),
  isHomePageRAREnabled: PropTypes.bool,
  isHpBirthdayModuleEnabled: PropTypes.bool,
  isHpNewDesignCTAEnabled: PropTypes.bool,
  isInGridPromo: PropTypes.bool,
};

ModuleDynamic.defaultProps = {
  isHomePage: false,
  moduleClassName: '',
  isHpNewModuleDesignEnabled: false,
  headerText: [],
  isHomePageRAREnabled: false,
  isHpBirthdayModuleEnabled: false,
  isHpNewDesignCTAEnabled: false,
  isInGridPromo: false,
};

ModuleDynamic.displayName = 'ModuleDynamic';

export default SafeComponent(connect(mapStateToProps, mapDispatchToProps)(ModuleDynamic));
